import React, { useState, createContext } from 'react'

export const AppContext = new createContext();

export const AppStateProvider = (props) => {
    const [appState, setAppState] = useState({
        userId: "1" ,
    });
    return (
        <AppContext.Provider value={[appState, setAppState]}>{props.children}</AppContext.Provider>)

}